import React, { useEffect } from 'react'
import { Card, Grid, csx, Text, Radio } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { useAssemblyItemsContext } from './context/AssemblyItemsContext'
import { isChecked } from './utils/isChecked'

type AssemblyItemSelectNoneProps = {
  currentAssemblyItemId: string
  displayName: string
  minQuantity: number
  maxQuantity: number
}

export const AssemblyItemSelectNone = ({
  currentAssemblyItemId,
  displayName,
  minQuantity,
  maxQuantity,
}: AssemblyItemSelectNoneProps) => {
  const { assemblyItemState, setAssemblyItemState } = useAssemblyItemsContext()
  const noneId = '0'

  const currentAssembly = {
    id: noneId,
    name: '',
    imageUrl: '',
    assemblyId: currentAssemblyItemId,
    seller: '',
  }

  const handleCheckAssemblyItem = () => {
    setAssemblyItemState(currentAssembly, minQuantity, maxQuantity)
  }

  useEffect(() => {
    if (
      !assemblyItemState.values.some(
        (v) => v.assemblyId === currentAssemblyItemId
      )
    ) {
      handleCheckAssemblyItem()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Card
      key={noneId}
      className={csx({
        display: 'grid',
        padding: '1.375rem',
        rowGap: '2.875rem',
        cursor: 'pointer',
        border: isChecked(assemblyItemState.values, currentAssembly)
          ? '$mainSelected'
          : '$neutral',
        ':hover': {
          background: '$blue05',
        },
      })}
      onClick={handleCheckAssemblyItem}
    >
      <Radio
        label=""
        value={noneId}
        checked={isChecked(assemblyItemState.values, currentAssembly)}
      />
      <Grid templateColumns="repeat(2, 1fr)">
        <Text>
          <FormattedMessage id="without" />
          {` ${displayName}`}
        </Text>
      </Grid>
    </Card>
  )
}
